import React from "react";
import { motion, useReducedMotion } from "framer-motion";
const steps = [{
  number: "01",
  title: "Realizás tu compra",
  description: "Completás el pago online."
}, {
  number: "02",
  title: "Recibís el acceso",
  description: "Accedés al material digital."
}, {
  number: "03",
  title: "Elegís qué fabricar",
  description: "Buscás la fórmula que necesitás."
}, {
  number: "04",
  title: "Avanzás a tu ritmo",
  description: "El acceso queda disponible."
}];
const enterEase = [0.22, 1, 0.36, 1] as const;
export function StartSimple() {
  const reduceMotion = useReducedMotion();
  return <section className="bg-white py-11 sm:py-16 lg:py-20" data-id="element-314" data-mp="2zepjh3zm311o">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 lg:px-10" data-id="element-315" data-mp="2zgae0tlxejzj">
        <motion.div className="text-center" initial={reduceMotion ? false : {
        opacity: 0,
        y: 6
      }} whileInView={reduceMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.4,
        ease: enterEase
      }} data-id="element-316" data-mp="2ug5zh94kvzby">
          <p className="text-[10px] font-extrabold tracking-[0.15em] text-[#0077e8]" data-id="element-317" data-mp="c18rvpfox739">ACCESO SIMPLE</p>
          <h2 className="mt-3 text-[28px] font-extrabold leading-[1.05] tracking-[-0.055em] text-[#091a37] sm:text-4xl" data-id="element-318" data-mp="gzk4g7xddvp6">Empezar es simple</h2>
          <p className="mt-3 text-[13px] text-[#657189]" data-id="element-319" data-mp="qx81x5md1hb1">Comprás una vez y accedés al material de forma digital.</p>
        </motion.div>

        <div className="relative mt-6 grid grid-cols-2 lg:mt-10 lg:grid-cols-4" data-id="element-320" data-mp="uxrxi4raccv2">
          <span aria-hidden="true" className="absolute bottom-0 left-1/2 top-0 w-px bg-[#c9e5f8] lg:hidden" data-id="element-321" data-mp="zxe806fqbf06" />
          <span aria-hidden="true" className="absolute left-0 right-0 top-1/2 h-px bg-[#c9e5f8] lg:hidden" data-id="element-322" data-mp="14ocszjbnx19r" />
          {steps.map((step, index) => <motion.article key={step.number} className={`relative min-h-[122px] px-4 py-4 text-left sm:min-h-[130px] sm:px-5 sm:py-[18px] lg:min-h-0 lg:px-7 lg:py-0 ${index === 0 ? "pl-0" : ""} ${index === 1 ? "lg:border-l lg:border-[#c9e5f8]" : ""} ${index === 2 ? "lg:border-l lg:border-[#c9e5f8]" : ""} ${index === 3 ? "lg:border-l lg:border-[#c9e5f8]" : ""}`} initial={reduceMotion ? false : {
          opacity: 0,
          y: 6
        }} whileInView={reduceMotion ? undefined : {
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.4,
          delay: 0.12 + index * 0.08,
          ease: enterEase
        }} data-id="element-323" data-mp="19psh5k94znwd" data-mpi={index}>
              <p className="text-[11px] font-extrabold text-[#0077e8]" data-id="element-324" data-mp="2c85xozsbem0">{step.number}</p>
              <h3 className="mt-2 text-[15px] font-extrabold leading-[1.1] tracking-[-0.03em] text-[#091a37] sm:text-base" data-id="element-325" data-mp="3tg6on6v4k2zr">{step.title}</h3>
              <p className="mt-2 text-[12px] leading-[1.35] text-[#657189]" data-id="element-326" data-mp="79hul2fcnm8s">{step.description}</p>
              {index < steps.length - 1 && <span aria-hidden="true" className="absolute right-[-6px] top-1/2 z-10 hidden -translate-y-1/2 bg-white px-1 text-sm text-[#0077e8] lg:block" data-id="element-327" data-mp="2d382470rpbxe">→</span>}
            </motion.article>)}
        </div>
      </div>
    </section>;
}